import { Flex, Space, Tag, Typography } from "antd"
import { PaymentMethodSummary } from "../../domain/invoicing/payment"
import { buildPaymentMethodSecondaryText, canPaymentMethodBeUsed } from "./PayInvoice/payInvoiceModel"
import PaymentMethodIcon from "./PaymentMethodIcon"

const PaymentMethodDisplay = ({ summary, width }: { summary: PaymentMethodSummary, width?: string }) => {
  return <Flex justify="space-between" gap={8} align="center" style={width ? { width } : undefined}>
    <Space>
      <PaymentMethodIcon type={summary.methodType} />
      <div>
        {summary.name}
        <br/>
        <Typography.Text type="secondary" disabled={!canPaymentMethodBeUsed(summary)} style={{ fontSize: '0.8em'}}>
          {buildPaymentMethodSecondaryText(summary)}
        </Typography.Text>
      </div>
    </Space>
    <PaymentMethodStatusTag summary={summary} />
  </Flex>
}

export default PaymentMethodDisplay

export const PaymentMethodStatusTag = ({summary}: {summary: PaymentMethodSummary}) => {
  if (summary.isExpired) {
    return <Tag color="#666666">Expired</Tag>
  }

  if (!summary.isActive) {
    return <Tag color="#666666">Inactive</Tag>
  }

  return null
}
